import { useQuery } from "react-query";
import axiosInstance from "../../axios/axios";
export function fetchCMS() {
  const fetchData = async () =>
    await axiosInstance.get("/unauth/getcms").then((res) => res.data.data);

  const { isLoading, error, data } = useQuery({
    queryKey: ["cmsData"],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: true,
    initialData: undefined,
    placeholderData: undefined,
  });

  return { isLoading, error, data };
}
